import { MoreVert } from "@mui/icons-material";
import { IconButton, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import QRCode from "react-qr-code";

const ProductGroupItem = ({ handleContextMenu, handleClick, group }) => {
  return (
    <Paper
      elevation={1}
      sx={{ height: 120, cursor: "pointer" }}
      onContextMenu={(e) => handleContextMenu(e, group)}
    >
      <Stack direction="row">
        {group.image ? (
          <LazyLoadImage
            style={{
              objectFit: "cover",
              height: 120,
              width: 120,
            }}
            alt=""
            src={group.image}
          />
        ) : (
          <QRCode
            size={120}
            style={{ height: "auto", maxWidth: 120, width: 120 }}
            value={group.qr_code}
            viewBox={`0 0 120 120`}
          />
        )}

        <Stack direction="column" flexGrow={1} paddingLeft={1}>
          <Stack
            padding={1}
            justifyContent="space-between"
            direction="row"
            alignItems="start"
          >
            <Typography
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                flexGrow: 1,
              }}
            >
              {group.name}
            </Typography>

            <IconButton onClick={(e) => handleClick(e, group)}>
              <MoreVert />
            </IconButton>
          </Stack>

          <Stack direction="row" sx={{ marginTop: 0.5 }}>
            <Typography gutterBottom variant="caption" component="div">
              Total products :
            </Typography>
            <Typography
              gutterBottom
              variant="overline"
              component="div"
              marginLeft={2}
              paddingY={0}
            >
              {group.items.length}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ProductGroupItem;
